import { createSmartrrModal } from "@vendor-app/utils/createModalStore";

export interface SequentialPreviewModalProps {}

export const useSequentialPreviewModal = createSmartrrModal<SequentialPreviewModalProps>();
